import { z } from "zod";

/**
 * Shared socket shapes for the collection-thread reminder steps. Defining them
 * once keeps the `query_stale_collection_threads` output element identical to
 * the `prepare_collection_reminder` input, so the fan-out edge type-checks.
 */
export const collectionReminderThreadSchema = z.object({
  id: z.string().uuid(),
  referenceNumber: z.number().int(),
  /** Rendered human-readable code, e.g. "COL-1024". */
  code: z.string(),
  title: z.string(),
  type: z.string(),
  customerName: z.string().nullable(),
  daysSinceLastActivity: z.number().int().nullable(),
  /** Linked invoice's remaining balance as a serialized money string. */
  dollarsAtRisk: z.string(),
});

/**
 * One Team member's reminder. Every member of the configured Team gets the same
 * full list of stale threads (assignment is not used yet); the fan-out is purely
 * so each recipient can be notified on their own preferred channels.
 */
export const recipientReminderBundleSchema = z.object({
  recipientUserId: z.string().uuid(),
  threadCount: z.number().int().nonnegative(),
  threads: z.array(collectionReminderThreadSchema),
});
